import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('certificates');

import { queryEditActive } from './service';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'certificates',

  state: {
    newCertificate: false,
    selectedItem: null,
    list: [],
    pagination: meta,
    select: 'id,isPinEnabled,created',
    notSelectSearch: 'isPinEnabled,created',
    expand: {
      user: { select: 'fullName' },
    },
    paramsEdit: {
      select: '',
      expand: {
        user: { select: 'id, fullName' },
      },
    },
    view: false,
    orderBy: '',
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'digitalCertificateData/paged',
          params: payload,
        });
        yield put({
          type: 'queryCertificates',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewCertificate({ payload }, { put }) {
      yield put({
        type: 'addCertificate',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewCertificate',
          payload,
        });
      }
    },
    *editItemCertificate({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'digitalCertificateData',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editCertificate',
          payload: {
            ...payload,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveNewCertificate({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'digitalCertificateData',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCertificate',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          // TODO: avoid direct pos access
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors || [],
          });
        }
      }
    },
    *saveEditCertificate({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'digitalCertificateData',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveCertificate',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error.message) {
          // TODO: avoid direct pos access
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ payload }, { call, put }) {
      yield put({
        type: `global/modalConfirm`,
        state: false,
        id: null,
      });
      try {
        const response = yield call(api.apiRoute, {
          route: `digitalCertificateData/${payload.id}`,
          method: 'delete',
        });
        yield put({
          type: 'deleteCertificate',
          payload: response,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${payload.view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: payload.view,
            },
          });
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
        }
      }
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *showItemCertificate({ view }, { put }) {
      yield put({
        type: 'showEditItemCertificate',
        view,
      });
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
  },
  reducers: {
    queryCertificates(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addCertificate(state, { payload }) {
      return {
        ...state,
        newCertificate: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editOrViewCertificate(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    editCertificate(state, { payload }) {
      return {
        ...state,
        selectedItem: { ...payload.item, userId: payload.item.userCreatorId },
        view: payload.view,
        id: payload.id,
      };
    },
    saveCertificate(state, { payload }) {
      return {
        ...state,
        saveCertificate: payload,
        newCertificate: false,
        selectedItem: null,
        id: null,
      };
    },
    deleteCertificate(state) {
      return {
        ...state,
      };
    },
    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },
    showEditItemCertificate(state, { view }) {
      return {
        ...state,
        view,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newCertificate: false,
        selectedItem: null,
        list: [],
        orderBy: '',
      };
    },
  },
};

export default Model;
